import { render, staticRenderFns } from "./VolumeSlider.vue?vue&type=template&id=bc3fdbe4&scoped=true&"
import script from "./VolumeSlider.vue?vue&type=script&lang=js&"
export * from "./VolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./VolumeSlider.vue?vue&type=style&index=0&id=bc3fdbe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fdbe4",
  null
  
)

export default component.exports